<template>
  <app-modal
    content-class="col-sm-12 col-md-5 col-lg-5 col-xl-4 p-0"
    @close="close"
    :top="true"
    :overflow="true"
    :closeable="true"
    :close-on-esc="true"
  >
    <b-card no-body>
      <b-card-body class="p-4">
        <div class="panel-close d-md-none" @click="close"><i class="ion ion-md-close"></i></div>
        <h5 class="mb-3">{{ title }}</h5>
        <div class="mb-3">
          <p class="text-danger"><b>WARNING</b>: This operation can't be reverted.</p>
        </div>
        <div class="form-check mb-3" v-if="canDeleteUser && hasUserDelete">
          <input class="form-check-input" type="checkbox" id="deleteUser" v-model="deleteRelatedUser" :disabled="deleting" />
          <label class="form-check-label" for="deleteUser">
            Delete related user
          </label>
        </div>
        <div class="form-check mb-3" v-if="canDeleteDesks">
          <input class="form-check-input" type="checkbox" id="deleteDesks" v-model="deleteInfinityDesks" :disabled="deleting"/>
          <label class="form-check-label" for="deleteDesks">
            Delete related desks (infinity bookings)
          </label>
        </div>
        <div class="btn-panel my-2">
          <div class="ml-auto"></div>
          <b-btn type="button" variant="danger" @click="confirmDelete" :disabled="deleting">
            <span v-if="deleting">Deleting...</span>
            <span v-else>Delete</span>
          </b-btn>
          <b-btn type="button" variant="default" @click="close" :disabled="deleting">Cancel</b-btn>
        </div>
      </b-card-body>
    </b-card>
  </app-modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as PN from '@/utils/PermissionNames'

export default {
  name: 'EmployeeDeleteModal',
  props: {
    employee: {
      type: Object,
      default: null
    },
    isBulk: {
      type: Boolean,
      default: false
    },
    onConfirm: {
      type: Function,
      required: true
    },
    hasUserDelete: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    PN,
    deleteRelatedUser: false,
    deleteInfinityDesks: false,
    deleting: false
  }),
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('rbac', ['can']),
    ...mapGetters('settings', ['scimUsersSyncEnabled']),
    title() {
      if (this.isBulk) {
        return 'Delete all employees?'
      }
      return `Delete employee "${this.employee?.name || ''}"?`
    },
    canDeleteUser() {
      return this.can(PN.USER_CRUD) && !this.scimUsersSyncEnabled
    },
    canDeleteDesks() {
      // Show option only if booking_enabled and has DESK_DELETE permission
      // If booking_enabled is false, option is hidden but always considered true in backend
      return this.user.booking_enabled && this.can(PN.DESK_DELETE)
    }
  },
  methods: {
    close() {
      if (!this.deleting) {
        this.$emit('close')
      }
    },
    async confirmDelete() {
      if (this.deleting) return

      this.deleting = true
      try {
        await this.onConfirm({
          deleteRelatedUser: this.deleteRelatedUser,
          deleteInfinityDesks: this.deleteInfinityDesks || !this.user.booking_enabled
        })
      } finally {
        this.deleting = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.panel-close {
  position: absolute;
  right: 25px;
  top: 20px;
  font-size: 24px;
  cursor: pointer;
}
</style>
